// 系统设置=>评级管理
import request from '@/plugins/axios'

const API_LIST = {
  RATE_LIST: '/rate/listRate',   //评级查询
  RATE_ADD: '/rate/addRate',    //新增评级
  RATE_UPDATE: '/rate/updateRate', //修改评级
  RATE_UPDATE_STATUS: '/rate/updateStatus', //修改评级状态
  
}
//获取评级列表
export function getRateListApi(params) {
  return request({ url: API_LIST.RATE_LIST, method: 'get', params})
}

//新增评级
export function addRateApi(data) {
  return request({ url: API_LIST.RATE_ADD, method: 'post', data})
}

//修改评级信息
export function updateRateApi(data) {
  return request({ url: API_LIST.RATE_UPDATE, method: 'post', data})
}

//修改评级状态
export function updateRateStatusApi(data) {
  return request({ url: API_LIST.RATE_UPDATE_STATUS, method: 'post', data})
}
